<template>
  <section>
    <div class="row justify-content-center" v-if="loading">
      <loading />
    </div>
    <div class="row" v-else>
      <div
        class="col-sm-6 col-md-4 col-lg-3"
        v-for="(produto, key) in produtos"
        :key="key"
      >
        <router-link
          class="text-center bg-white d-flex flex-column justify-content-center align-content-center pt-4 pb-5 mt-4 text-primary rounded"
          :to="produto.link"
        >
          <div><i class="material-icons text-warning">groups</i></div>
          <div class="font-weight-bold mt-2 h5">{{ produto.nome }}</div>
          <div class="text-dark">
            Capacidade {{ produto.capacidade }} pessoas
          </div>
          <div class="text-dark mt-2">
            {{ produto.valor | currency }} / {{ produto.tipoValor }}
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "CdlVarejoInteligente",
  data() {
    return {
      produto: {
        nome: "CDL Varejo Inteligente",
        id: "CDLVarejoInteligente",
      },
      breadcrumb: [
        {
          nome: "CDL Varejo Inteligente",
          id: "CDL Varejo Inteligente",
        },
      ],
      produtos: [],
      loading: true,
    };
  },
  methods: {},
  created() {
    sessionStorage.removeItem("reserva");
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.$http
      .get("/api/Agenda/ListarAgendas")
      .then((response) => {
        var link = "";
        var valores = [];
        response.data.forEach((produto) => {
           // Está fixo, remove assim que as salas voltarem ativa
          if(produto.agendaId !== "cdlbh.com.br_188dffj9esuv4j3dgtqseavichg6o" && produto.agendaId !== "cdlbh.com.br_1887dd5c47ptcht5kletsei1cjcgm6gb6krjed1p74qjge9l64" ){
            if (produto.espaco.match(/SALA/)) {
            link = "formulario/reuniao/" + produto.agendaId;
          } else if (produto.espaco.match(/ROOFTOP/)) {
            link = "formulario/rooftop/" + produto.agendaId;
          } else if (produto.espaco == "ESTAÇÃO DE TRABALHO") {
            link = "estacao-trabalho/" + produto.agendaId;
          } else if (produto.espaco === "ESCRITÓRIO VIRTUAL") {
            link =
              "formulario-estacao-trabalho/" +
              produto.agendaId +
              "/escritorio-virtual";
          }

          const dadosProduto = {
            nome: produto.espaco,
            capacidade: produto.capacidade,
            valor: produto.valorComDesconto
              ? produto.valorComDesconto
              : produto.valor,
            tipoValor: produto.tipoValor,
            link: link,
          };

          this.produtos.push(dadosProduto);
          valores.push({
            agendaId: produto.agendaId,
            valor: produto.valorComDesconto
              ? produto.valorComDesconto
              : produto.valor,
            capacidade: produto.capacidade,
          });   
          }        
        });

        this.loading = false;
        sessionStorage.setItem("valoresProdutos", JSON.stringify(valores));
      })
      .catch((error) => {
        if (error.statusCode === 401) {
          this.$router.push({ name: "login" });
        }

        this.loading = false;
        this.error = error.response.data.mensagem;
      });
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>

<style lang="scss" scoped>
.material-icons {
  font-size: 42px;
}
</style>
